import React from "react";
import { Grid, Typography, Box } from "@material-ui/core";
import { PhotoUploaderStyles } from "./PhotoUploaderStyles";

export const PhotoLandingPage = (props: any) => {
  const classes = PhotoUploaderStyles();
  console.log(props.photoCount);
  console.log(props.uploadedPhotoCount);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <label style={{ color: "white" }}>-</label>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        <Typography className={classes.landpageHeader}>
          <span
            className="icon-complete-circle"
            style={{
              color: "#4CA633",
              marginRight: "10px",
              paddingTop: "20px !important",
            }}
          ></span>
          You’ve uploaded {props.uploadedPhotoCount} photos to your claim.
        </Typography>
      </Grid>
      <Grid item xs={12} className={classes.NextStepInfo}>
        <Typography className={classes.NextStepInfo}>Next Steps</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.nextStepDesc}>
          Your photos are being processed. You’ll be able to view them in your
          claim details soon. <br />
          Select <b>Continue to Rental</b> to reserve a rental car to use while
          your vehicle is undergoing repairs. <br /> Don’t want to reserve a
          rental car now? You can do it later from the
          <b> Claim Details</b> page.
        </Typography>
      </Grid>
    </Grid>
  );
};
export default PhotoLandingPage;
